import { createFilterStore } from './createFilterStore';

export const useExpenseFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  status: '',
  categoryId: '',
  accountId: '',
  minAmount: '',
  maxAmount: '',
  // datePreset is UI-only (drives the dropdown); dateFrom/dateTo go to the API.
  datePreset: 'all',
  dateFrom: '',
  dateTo: '',
  sortBy: 'createdAt',
  sortOrder: 'desc' as const,
});
